import React, { FC, useContext } from 'react';
import { Hyperlink } from '../../components/Hyperlink';
import { isUrlInternal } from '../../utils/url-utils/urlUtils';
import { UserContext } from '../../user/UserContext';
import { CommentaryHeader } from './CommentaryHeader';
import { CommentarySubtext } from './CommentarySubtext';
import { WebCommentary } from '../commentary.types';
import { RestrictedModalCommentaries } from '../../components/modal/components/modal-restricted/RestrictedModalCommentaries';
import { ModalContext } from '../../components/modal/ModalContext';

type Props = {
  commentary: WebCommentary;
  onCommentaryClicked: Function;
  source: string;
  className?: string;
  small?: boolean;
};

export const OpenCommentaryCard: FC<Props> = ({
  commentary,
  source,
  className,
  onCommentaryClicked,
  small = false,
}) => {
  const { accessPremium } = useContext(UserContext);
  const { openModal } = useContext(ModalContext);

  const handleClick = () => {
    if (accessPremium) {
      onCommentaryClicked(commentary);
    } else {
      openModal(modalProps => (
        <RestrictedModalCommentaries source={source} {...modalProps} />
      ));
    }
  };

  const isDoctrineLink = isUrlInternal(commentary.url);
  return (
    <Hyperlink
      onClick={handleClick}
      {...(accessPremium
        ? {
            href: commentary.url,
            source: isDoctrineLink ? source : '',
            target: isDoctrineLink ? '' : '_blank',
            rel: isDoctrineLink ? '' : 'nofollow',
          }
        : {})}
      className={className}
    >
      <CommentaryHeader
        commentary={commentary}
        isDoctrineLink={isDoctrineLink}
        small={small}
      />
      <CommentarySubtext
        commentary={commentary}
        isDoctrineLink={isDoctrineLink}
      />
    </Hyperlink>
  );
};
